export default __webpack_public_path__ + "static/media/AC070-income tax _ income,  tax, pago, impuestos, percentage.bffeaa69.svg";